import getDictionaryMatch from './get-dictionary-match';
import { propsSchema } from './entities/constants';

function getGenericProps(props = propsSchema) {
  const { itemsPerRow } = props;
  const gridModifier = getDictionaryMatch(itemsPerRow);

  return { gridModifier, ...props };
}

export default getGenericProps;
